import * as React from "react";
import Grid from "@mui/material/Grid";
import {
  useLoadBatteryVoltageDataMutation,
  useLoadInternalTempDataMutation
} from "../../store";
import { useLoadExternalTempDataMutation } from "../../store";
import { RenderSelectDeviceButton } from "./RenderSelectDeviceButton";
import { Device } from "../../store/apis/devicesApi";
import { useEffect, useState } from "react";
import { RenderLineChart } from "./RenderLineChart";
import { Button } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Fab from "@mui/material/Fab";
import CachedIcon from "@mui/icons-material/Cached";

enum ViewType {
  DAY,
  WEEK
}

export default function Measurementresults() {
  const [selectedDevice, setSelectedDevice] = useState<Device>();
  const [start, setStart] = useState(new Date(new Date().setHours(0, 0, 0)));
  const [end, setEnd] = useState(new Date(new Date().setHours(23, 59, 59)));
  const [viewType, setViewType] = useState(ViewType.DAY);

  const [loadTemp, loadTempResult] = useLoadInternalTempDataMutation();
  const [
    loadExternalTemp,
    loadExternalTempResult
  ] = useLoadExternalTempDataMutation();
  // const [
  //   loadBatteryVoltage,
  //   loadBatteryVoltageResult
  // ] = useLoadBatteryVoltageDataMutation();

  useEffect(() => {
    if (selectedDevice) {
      loadTemp({
        device: selectedDevice,
        startTime: start,
        endTime: end
      });
      loadExternalTemp({
        device: selectedDevice,
        startTime: start,
        endTime: end
      });
      // loadBatteryVoltage({
      //   device: selectedDevice,
      //   startTime: start,
      //   endTime: end
      // });
    }
  }, [
    selectedDevice,
    loadTemp,
    loadExternalTemp,
    // loadBatteryVoltage,
    start,
    end
  ]);

  const onPrevClick = () => {
    const minusDays = viewType === ViewType.DAY ? 1 : 7;
    setStart(new Date(start.setDate(start.getDate() - minusDays)));
    setEnd(new Date(end.setDate(end.getDate() - minusDays)));
  };

  const onNextClick = () => {
    const plusDays = viewType === ViewType.DAY ? 1 : 7;
    setStart(new Date(start.setDate(start.getDate() + plusDays)));
    setEnd(new Date(end.setDate(end.getDate() + plusDays)));
  };

  const handleClick = () => {
    if (viewType === ViewType.DAY) {
      const currentDay = start.getDay();
      const minusDays = currentDay === 0 ? 6 : currentDay - 1;
      setStart(new Date(start.setDate(start.getDate() - minusDays)));
      setEnd(new Date(start.setDate(start.getDate() + 7)));
      setViewType(ViewType.WEEK);
    } else {
      setStart(new Date(new Date().setHours(0, 0, 0)));
      setEnd(new Date(new Date().setHours(23, 59, 59)));
      setViewType(ViewType.DAY);
    }
  };

  const dateString =
    viewType === ViewType.DAY ? start.toLocaleDateString() : "";

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RenderSelectDeviceButton setSelectedDevice={setSelectedDevice} />
          <RenderLineChart
            data={loadExternalTempResult.data}
            title={`Sensorin lämpötila ${dateString}`}
          />
          <div style={{ width: "100%" }}>
            <Grid container justifyContent={"space-between"}>
              <Fab color="primary" aria-label="add" onClick={onPrevClick}>
                <ArrowBackIosIcon />
              </Fab>
              <Fab
                color="primary"
                style={{ float: "right" }}
                aria-label="add"
                onClick={onNextClick}
              >
                <ArrowForwardIosIcon />
              </Fab>
            </Grid>
          </div>
          <RenderLineChart
            data={loadTempResult.data}
            title={`Laitteen sisälämpötila ${dateString}`}
          />

          {/*<RenderLineChart*/}
          {/*  data={loadBatteryVoltageResult.data}*/}
          {/*  title={"Pariston jännite"}*/}
          {/*/>*/}
          <Button
            size="small"
            style={{ float: "right" }}
            variant={"outlined"}
            startIcon={<CachedIcon />}
            onClick={handleClick}
          >
            {viewType === ViewType.DAY ? "Viikkonäkymä" : "Päivänäkymä"}
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
